module.exports = __webpack_public_path__ + "564dbb5416374f73cbba7a43babff098.svg";